import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.promise";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
export default {
  name: 'MediaFileUpload',
  props: {
    type: {
      type: String,
      default: ''
    },
    accept: {
      type: String,
      default: 'text/csv'
    },
    title: {
      type: String,
      default: ''
    },
    buttonIcon: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      file: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])), {}, {
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  }),
  methods: {
    onUploadBtnClick: function onUploadBtnClick() {
      // eslint-disable-next-line no-empty-function
      window.addEventListener('focus', function () {}, {
        once: true
      });
      this.$refs.file.click();
    },
    handleFileUpload: function () {
      var _handleFileUpload = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event) {
        var input, file, fileContents, result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                input = event.target;

                if (!(input.files && input.files[0])) {
                  _context.next = 16;
                  break;
                }

                file = input.files[0];
                _context.prev = 3;
                _context.next = 6;
                return this.readUploadedFileAsText(file);

              case 6:
                fileContents = _context.sent;
                result = fileContents;
                this.file = result;
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](3);
                this.file = _context.t0.message;

              case 14:
                this.$emit('file', this.file);
                event.target.value = '';

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 11]]);
      }));

      function handleFileUpload(_x) {
        return _handleFileUpload.apply(this, arguments);
      }

      return handleFileUpload;
    }(),
    readUploadedFileAsText: function readUploadedFileAsText(file) {
      var _this = this;

      var fileReader = new FileReader();
      return new Promise(function (resolve, reject) {
        fileReader.onerror = function () {
          fileReader.abort();
          reject(_this.$i18n_t('NiotaClassic.Devices.snacks.fileUploadError'));
        };

        fileReader.onload = function () {
          resolve(fileReader.result);
        };

        fileReader.readAsText(file);
      });
    }
  }
};